/** @format */

// 查询未读消息列表
import { request } from '@power/runtime-vue3';
import type { BaseResponse } from '@power/runtime-vue3';
import * as V1 from '@/api/version-v1';

export function queryNotReadMsgList() {
	if ('V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION) {
		return V1.queryNotReadMsgList();
	}
	return request<BaseResponse<API.BaseMessageResult>>({
		url: '/base/msg/inner/queryNotReadMsgList',
		method: 'get',
	});
}
// 标记为已读
export function updateMessageState(data) {
	return request<BaseResponse<API.BaseMessageResult>>({
		url: '/base/msg/inner/updateMessageState',
		method: 'post',
		params: data,
	});
}
// 发送消息
export function sendSocketMessage(data) {
	return request<BaseResponse<API.BaseMessageResult>>({
		url: '/base/msg/rbacMessage/sendMessage',
		method: 'post',
		data,
	});
}

export function getNoticeOrMsgList(data) {
	return request({
		url: `/powerportal/v1/widget/getData/noticeOrMsgList`,
		type: 'post',
		data,
	});
}

export function getUnReadMsgCount(data) {
	return request({
		url: `/powerportal/v1/widget/getData/unReadMsgCount`,
		type: 'post',
		data,
	});
}
